import { IInventoryPage } from '../../inventory-page.interface';


export const TUTORIALS_BY_TUTORIALURL_PAGE: IInventoryPage = {
	'route': '/tutorials/:tutorialUrl',
	'title': 'Tutorial',
	'uiReference': [],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/tutorials/tutorials-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/tutorials/tutorial/tutorial.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/tutorials/tutorial/tutorial.component.html'
	]
};
